import React, { lazy } from 'react';
import { SubRouter, Route, useLocation } from 'reaouter';
import { Transition, TransitionGroup } from 'myt-react-snippets';
import { LandingFacade } from 'Source/App/Main/Facades';
import { Warning } from 'Templates';
import { ReactPage, JavascriptPage, NeumorphismPage, Unsubscribe} from '../Pages'

const Header = lazy(() => import('../Header'));

const DocumentationPages = () => {
	const { pathname } = useLocation();
	// this is to prevent nested routes as new keys. that allows only the parent route path is the key
	const nested_routes = ['/react'];
	const key =
		nested_routes.find((route) => pathname.indexOf(route + '/') === 0) ||
		pathname;
	return (
		<>
			<Header />
			<TransitionGroup>
				<Transition className='fade-content' timing={300} key={key}>
					<main className='wrapper'> 
						<LandingFacade>
							<SubRouter path='/react' render={<ReactPage />} />
							<SubRouter path='/javascript' render={<JavascriptPage />} />
							<SubRouter path='/neumorphism' render={<NeumorphismPage />} />
							<Route path='/unsubscribe/:email' render={<Unsubscribe />} />
						</LandingFacade>
					</main>
				</Transition>
			</TransitionGroup>
			<Warning title="Warning!" message={<p>In this pre-deployed stage, most of the library you will witness has yet been publish or update in npm.</p>} />
		</>
	);
};

export default DocumentationPages